<template>
  <div class="container">
    <div>
      <slot name="filters" data="filters">
        <div>
          <t-input v-model="filter.query" placeholder="Cerca testo"></t-input>
        </div>
      </slot>
    </div>

    <div class="col-span-full">
      <div class="flex justify justify-end">
        <t-button native href="#" @click="fetchData" variant="neutral">
          <span
            >Aggiorna ricerca<i
              class="mx-2 fas fa-sync-alt fa-spin"
              v-show="loading"
            ></i>
          </span>
        </t-button>
      </div>

      <div>
        <slot data="items" />
      </div>

      <div>
        <slot name="pagination" data="pagination">
          <t-pagination
            :total-items="pagination.totalItems"
            :per-page="pagination.perPage"
            :limit="pagination.limit"
            v-model="pagination.currentPage"
          ></t-pagination>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Function,
      default: () => {},
      required: true,
    },
  },
  data() {
    return {
      items: [],
      filters: {
          query: null
      },
      pagination: {
        totalItems: 0,
        perPage: 20,
        limit: 5,
        currentPage: 1,
      },

      loading: false,
    };
  },

  methods: {
    async fetchData() {
      try {
        var response = await this.data();
      } catch (error) {
        this.$awn.danger("Si è verificato un errore. Impossibil procedere");
      }

      this.items = response;
    },
  },
};
</script>
